export const APP_STORE_URL = 'https://apps.apple.com/it/app/smartcaf/id6739075797'
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=it.smartcaf&hl=it'
